"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractErrorMessage = exports.DEFAULT_EXTRACT_ERROR_MESSAGE = exports.EXTRACT_ERROR_KEYS = void 0;
var lodash_1 = require("lodash");
var typeUtilities_1 = require("./typeUtilities");
exports.EXTRACT_ERROR_KEYS = ['error', 'errors', 'message', 'Message', 'detail'];
exports.DEFAULT_EXTRACT_ERROR_MESSAGE = 'An unknown error occurred.';
function extractErrorMessage(error) {
    var e_1, _a;
    if (typeof error === 'string') {
        return error;
    }
    if (Array.isArray(error)) {
        return extractErrorMessage(error[0]);
    }
    if ((0, lodash_1.isObject)(error)) {
        try {
            for (var EXTRACT_ERROR_KEYS_1 = __values(exports.EXTRACT_ERROR_KEYS), EXTRACT_ERROR_KEYS_1_1 = EXTRACT_ERROR_KEYS_1.next(); !EXTRACT_ERROR_KEYS_1_1.done; EXTRACT_ERROR_KEYS_1_1 = EXTRACT_ERROR_KEYS_1.next()) {
                var key = EXTRACT_ERROR_KEYS_1_1.value;
                if ((0, typeUtilities_1.hasKey)(error, key)) {
                    return extractErrorMessage(error[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (EXTRACT_ERROR_KEYS_1_1 && !EXTRACT_ERROR_KEYS_1_1.done && (_a = EXTRACT_ERROR_KEYS_1.return)) _a.call(EXTRACT_ERROR_KEYS_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return exports.DEFAULT_EXTRACT_ERROR_MESSAGE;
}
exports.extractErrorMessage = extractErrorMessage;
